export enum JourneySuggestionType {
  OBJECTIVE = 1,
  REACH = 2,
  DEPTH = 3,
  INTERACTION = 4,
  KEY_MESSAGE = 5,
  CONTENT = 6,
}

export interface PerformanceMetricDisplay {
  label: string;
  value: string;
  trendValue: number | null;
  formattedTrendValue: string;
}

export interface ProductWithAdoptionLadder {
  id: string;
  name: string;
  productRatingId: string;
  adoptionLadderId: string;
  adoptionLadderRank: number;
  adoptionLadderName: string;
  selected: boolean;
}

export interface ContentItem {
  contentListData: any[];
  valuePopupText: string;
  popupListData: any[];
}

export interface JourneySuggestionCategory {
  type: JourneySuggestionType;
  categoryName: string;
  items: any[] | ContentItem;
}

export interface LadderStage {
  stageId: string;
  stageName: string;
  rank: number;
  indexedRank: number;
}

export interface LadderHistoryEntry {
  transactionLogId: string;
  previousStageId: string | null;
  previousStageName: string;
  previousStageRank: number;
  newStageId: string;
  newStageName: string;
  newStageRank: number;
  changedOn: string;
  changedByUserName: string;
  direction: 'up' | 'down' | 'same' | null;
}

export interface LadderDataPerType {
  productRatingId: string;
  ladderTypeId: string;
  ladderTypeName: string;
  isEditable: boolean;
  isVisible: boolean;
  currentStageId: string;
  currentStageName: string;
  currentStageRank: number;
  goalStageId: string;
  allStages: LadderStage[];
  history: LadderHistoryEntry[] | null;
}

export interface ProductWithMultipleLadders {
  id: string;
  name: string;
  ladders: LadderDataPerType[];
  selected: boolean;
  isCompetitorProduct?: boolean;
}
